import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthenticationFacade } from '../auth';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private readonly URL_FRAGMENTS_WITHOUT_AUTH = [
    './',
    'res/api/file',
    'res/api/data/passwordoptions',
    'res/api/utils',
    '.well-known',
    'auth/connect',
  ];
  private readonly auth = inject(AuthenticationFacade);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestRequiresToken = this.requestRequiresToken(request);
    if (!requestRequiresToken) {
      return next.handle(request);
    }

    return from(this.auth.getAccessToken()).pipe(
      switchMap((authToken) => {
        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return next.handle(authReq);
      }),
    );
  }

  private requestRequiresToken(req: HttpRequest<unknown>): boolean {
    return !this.URL_FRAGMENTS_WITHOUT_AUTH.some((token) => req.url.includes(token));
  }
}
